"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from "react";
export function useCurrentTime() {
  const $ = _c(5);
  const [now, setNow] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const currentTime = Date.now();
      setNow(currentTime);
      return currentTime;
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const refreshCurrentTime = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      refreshCurrentTime();
      const timer = window.setInterval(refreshCurrentTime, 60000);
      window.addEventListener("focus", refreshCurrentTime);
      document.addEventListener("visibilitychange", refreshCurrentTime);
      return () => {
        window.clearInterval(timer);
        window.removeEventListener("focus", refreshCurrentTime);
        document.removeEventListener("visibilitychange", refreshCurrentTime);
      };
    };
    t2 = [refreshCurrentTime];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== now) {
    t3 = {
      now,
      refreshCurrentTime
    };
    $[3] = now;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}